export enum ModalID {
  CHART_ZOOM = 'modal-chart-zoom',
  CONFIG = 'modal-config'
}